/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiativeDimensionScoreDto
 */
export interface InitiativeDimensionScoreDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    dimensionId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    dimensionKey?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    dimensionDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    dimensionDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    primaryCsfFunction?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    effectiveWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    baselineScore?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    currentScore?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    targetScore?: number;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    dataSource?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    designedScore?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    operationalScore?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    operationalScoreUnit?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    validatedScore?: number;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    operationalStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeDimensionScoreDto
     */
    operationalCalculatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    operationalWindowInstanceCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    operationalScore30dAgo?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    operationalGap?: number;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeDimensionScoreDto
     */
    validatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    validatedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitiativeDimensionScoreDto
     */
    aiGenerated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    aiModelVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeDimensionScoreDto
     */
    humanReviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    humanReviewedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDimensionScoreDto
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDimensionScoreDto
     */
    version?: number;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeDimensionScoreDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeDimensionScoreDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the InitiativeDimensionScoreDto interface.
 */
export function instanceOfInitiativeDimensionScoreDto(value: object): value is InitiativeDimensionScoreDto {
    return true;
}

export function InitiativeDimensionScoreDtoFromJSON(json: any): InitiativeDimensionScoreDto {
    return InitiativeDimensionScoreDtoFromJSONTyped(json, false);
}

export function InitiativeDimensionScoreDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeDimensionScoreDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'dimensionKey': json['dimensionKey'] == null ? undefined : json['dimensionKey'],
        'dimensionDisplayName': json['dimensionDisplayName'] == null ? undefined : json['dimensionDisplayName'],
        'dimensionDomain': json['dimensionDomain'] == null ? undefined : json['dimensionDomain'],
        'primaryCsfFunction': json['primaryCsfFunction'] == null ? undefined : json['primaryCsfFunction'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'effectiveWeight': json['effectiveWeight'] == null ? undefined : json['effectiveWeight'],
        'baselineScore': json['baselineScore'] == null ? undefined : json['baselineScore'],
        'currentScore': json['currentScore'] == null ? undefined : json['currentScore'],
        'targetScore': json['targetScore'] == null ? undefined : json['targetScore'],
        'dataSource': json['dataSource'] == null ? undefined : json['dataSource'],
        'designedScore': json['designedScore'] == null ? undefined : json['designedScore'],
        'operationalScore': json['operationalScore'] == null ? undefined : json['operationalScore'],
        'operationalScoreUnit': json['operationalScoreUnit'] == null ? undefined : json['operationalScoreUnit'],
        'validatedScore': json['validatedScore'] == null ? undefined : json['validatedScore'],
        'operationalStatus': json['operationalStatus'] == null ? undefined : json['operationalStatus'],
        'operationalCalculatedAt': json['operationalCalculatedAt'] == null ? undefined : (new Date(json['operationalCalculatedAt'])),
        'operationalWindowInstanceCount': json['operationalWindowInstanceCount'] == null ? undefined : json['operationalWindowInstanceCount'],
        'operationalScore30dAgo': json['operationalScore30dAgo'] == null ? undefined : json['operationalScore30dAgo'],
        'operationalGap': json['operationalGap'] == null ? undefined : json['operationalGap'],
        'validatedAt': json['validatedAt'] == null ? undefined : (new Date(json['validatedAt'])),
        'validatedBy': json['validatedBy'] == null ? undefined : json['validatedBy'],
        'aiGenerated': json['aiGenerated'] == null ? undefined : json['aiGenerated'],
        'aiModelVersion': json['aiModelVersion'] == null ? undefined : json['aiModelVersion'],
        'humanReviewedAt': json['humanReviewedAt'] == null ? undefined : (new Date(json['humanReviewedAt'])),
        'humanReviewedBy': json['humanReviewedBy'] == null ? undefined : json['humanReviewedBy'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'version': json['version'] == null ? undefined : json['version'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function InitiativeDimensionScoreDtoToJSON(json: any): InitiativeDimensionScoreDto {
    return InitiativeDimensionScoreDtoToJSONTyped(json, false);
}

export function InitiativeDimensionScoreDtoToJSONTyped(value?: InitiativeDimensionScoreDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'initiativeId': value['initiativeId'],
        'dimensionId': value['dimensionId'],
        'dimensionKey': value['dimensionKey'],
        'dimensionDisplayName': value['dimensionDisplayName'],
        'dimensionDomain': value['dimensionDomain'],
        'primaryCsfFunction': value['primaryCsfFunction'],
        'weight': value['weight'],
        'effectiveWeight': value['effectiveWeight'],
        'baselineScore': value['baselineScore'],
        'currentScore': value['currentScore'],
        'targetScore': value['targetScore'],
        'dataSource': value['dataSource'],
        'designedScore': value['designedScore'],
        'operationalScore': value['operationalScore'],
        'operationalScoreUnit': value['operationalScoreUnit'],
        'validatedScore': value['validatedScore'],
        'operationalStatus': value['operationalStatus'],
        'operationalCalculatedAt': value['operationalCalculatedAt'] == null ? undefined : ((value['operationalCalculatedAt']).toISOString()),
        'operationalWindowInstanceCount': value['operationalWindowInstanceCount'],
        'operationalScore30dAgo': value['operationalScore30dAgo'],
        'operationalGap': value['operationalGap'],
        'validatedAt': value['validatedAt'] == null ? undefined : ((value['validatedAt']).toISOString()),
        'validatedBy': value['validatedBy'],
        'aiGenerated': value['aiGenerated'],
        'aiModelVersion': value['aiModelVersion'],
        'humanReviewedAt': value['humanReviewedAt'] == null ? undefined : ((value['humanReviewedAt']).toISOString()),
        'humanReviewedBy': value['humanReviewedBy'],
        'notes': value['notes'],
        'version': value['version'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

